<article class="order">
  <div class="order-actions">
    <button
      id="open-order-btn"
      type="button"
      class="btn btn-ignore"
      (click)="openOperationItemModal()"
    >
      <i class="fa-solid fa-circle-info"></i>
    </button>

    <button
      [oaiboxAuthorizedRoles]="[UserRole.CTO]"
      id="open-logs-btn"
      type="button"
      class="btn btn-ignore"
      (click)="openOrderLogsModal()"
    >
      <i class="fa-solid fa-file-lines"></i>
    </button>

    <button
      [oaiboxAuthorizedRoles]="[UserRole.CTO]"
      id="delete-order-btn"
      type="button"
      class="btn btn-ignore"
      (click)="openDeleteOrderModal()"
    >
      <i class="fa-solid fa-trash"></i>
    </button>
  </div>

  <section class="order-info">
    <div>
      <h1 class="order-title">{{ order.title }}</h1>
      <div class="order-details">
        <div class="order-dates">
          <span>Start Date: {{ order.startDate | date: "yyyy-MM-dd" }}</span>
          <span [class.overdue-date]="dueDateIsOverdue">
            Due Date: {{ order.dueDate | date: "yyyy-MM-dd" }}
          </span>
        </div>

        @if (orderStateLabel) {
          <div class="order-fulfilment">
            <span class="order-state">{{ orderStateLabel | uppercase }}</span>
            <ol
              class="fulfilment-steps"
              [class.overdue]="dueDateIsOverdue"
              [class.complete]="isBringupDone"
            >
              @for (step of fulfilmentSteps; track step.type) {
                <li [class.reached]="step.reached" [title]="step.label"></li>
              }
            </ol>
          </div>
        }
      </div>
    </div>

    @let hasCustomerData = order.customerName || order.customerEmailAddress;
    @if (hasCustomerData) {
      <div class="d-flex flex-column">
        <span class="fw-bold">{{ order.customerName }}</span>
        <span>{{ order.customerEmailAddress }}</span>
        <div class="under-label">Customer</div>
      </div>
    }
  </section>

  <section class="buttons-wrapper">
    <button
      class="btn btn-secondary bom-button"
      (click)="openBillOfMaterialsModal()"
    >
      <i class="fa-solid fa-cart-minus"></i>
      Bill of Materials
    </button>

    @if (
      order.orderType !== OrderType.AWAITING_PROCUREMENT &&
      order.orderType !== OrderType.INTEGRATING_AND_TESTING
    ) {
      <button
        class="btn btn-warning tenant-assignment-button"
        (click)="openOrderTenantAssignmentModal()"
      >
        <i class="fa-solid fa-building-magnifying-glass"></i>
        Assign Tenants
      </button>
    }

    @if (
      order.orderType !== OrderType.AWAITING_PROCUREMENT &&
      order.orderType !== OrderType.INTEGRATING_AND_TESTING &&
      order.orderType !== OrderType.PACKING
    ) {
      <button
        class="btn btn-success tracking-details-button"
        (click)="openOrderTrackingDetailsConfigurationModal()"
      >
        <i class="fa-solid fa-truck-fast"></i>
        Add Tracking Details
      </button>
    }
  </section>
</article>
